import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_PUBLIC_FORUM_BY_ID } from "../Schema/PublicForum";

export const useGetPublicForumById = ({id}) => {

  const [loading, setLoading] = useState(true);
  const [publicForumData, setPublicForumData] = useState([]);

  const { refetch: refetchWorkGroupById } = useQuery(GET_PUBLIC_FORUM_BY_ID, {
    variables: {
      id: id,
    },
    onCompleted: ({ getPublicForumById }) => {
        setPublicForumData(getPublicForumById || []);
        setLoading(false);
    },
    onError: (err) => {
        console.log("Error::", err?.message);
    },
  });

    useEffect(() => {
        refetchWorkGroupById();
    }, []);


  return { publicForumData, refetchWorkGroupById };
};
